import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { changeBomLineItemExtraParts } from 'pcb-parts/slice/bomSlice';

const ExtraParts = (props) => {
  const dispatch = useDispatch();
  const [tempValue, setTempValue] = useState(null);

  const {
    index,
    board_qty,
    part_selected,
    part_supplier_selected,
    show_qty_price,
    calculated_minimun_order_qty,
    exact_qty,
    extra_parts,
    user_action,
    allow_edit,
  } = props;

  if (!show_qty_price) return <span>-</span>;
  if (user_action === 'buy_stock' || !allow_edit)
    return <span>{extra_parts}</span>;

  const min_extra_parts = calculated_minimun_order_qty - exact_qty;

  const onChangeInput = (e) => setTempValue(e.target.value);

  const onKeyDown = (e) => {
    if (e.key === 'Enter') e.target.blur();
  };

  const onChangeExtraParts = () => {
    const new_extra_parts = tempValue / 1;
    if (new_extra_parts < min_extra_parts || !part_selected) {
      setTempValue(min_extra_parts);
      return;
    }
    dispatch(
      changeBomLineItemExtraParts({
        idx: index,
        board_qty,
        data: {
          type: part_supplier_selected ? 'single' : 'multiple',
          extra_parts: new_extra_parts,
        },
      }),
    );
  };

  const onExit = () => {
    onChangeExtraParts();
  };

  return (
    <input
      id={`bom-line-item-extra-parts-${index}`}
      className='form-control'
      type='number'
      min={min_extra_parts}
      value={tempValue || extra_parts}
      onChange={onChangeInput}
      onBlur={onExit}
      onKeyDown={onKeyDown} />
  );
};

export default ExtraParts;
